define([
    'require',
    './form',
    './field-datepicker',
    // 'field-dropzone',
    // 'field-creditCard',
    // 'field-autocomplete',
    // 'field-rating'
    './field-address'
], function(
    require,
    Form,
    Datepicker,
    // Dropzone,
    // CreditCard,
    // Autocomplete,
    // Rating
    Address
) {
    var _self;
    // console.log('field');

    // circular dependencies
    Form = require(['./form'], function(foo) {
        Form = foo;
    });

    // obj
    _self = {
        qtyInput: function($control) {
            var $field = $control.closest('.field'),
                $input = $field.find('.field__input'),
                value = Number($input.val()),
                type = $control.is('.field__control--plus') ? 'plus' : 'minus';

            if (type == 'plus') {
                $input.val(value + 1);
            } else {
                $input.val(value - 1);
            }

            if (Number($input.val()) < 1) {
                $input.val(1);
            }

            $input.trigger('change');
        },

        selectTab: function($input) {
            var $field = $input.closest('.field'),
                index = $input[0].selectedIndex,
                $tabs = $field.next('.field-tabs'),
                $allTabs = $tabs.children(),
                $tab = $allTabs.eq(index - 1);

            $allTabs.removeClass('active');

            if (index) {
                $tab.addClass('active');
            }
        },
        selectURL: function($input) {
            var url = $input.val();
            window.location.href = url;
        },
        edit: function($trigger) {
            var $field = $trigger.closest('.field'),
                $input = $field.find('.field__input'),
                type = $trigger.data('edit-field') || false;

            // remove attr
            $input.removeAttr('readonly disabled');

            // keep original value
            if (!$input.data('value')) {
                $input.data('value', $input.val());
            }

            if (type) {
                $input.data('type', $input.attr('type'));
                $input.attr('type', type);
            }

            // reset field
            $input.val('');

            // bind blur function
            $input.off('blur.edit-field');
            $input.on('blur.edit-field', function() {
                if (!$input.val()) {
                    $input.val($input.data('value')).attr('readonly', 'readonly');
                    $input.attr('type', $input.data('type'));
                }
            });
        },
        checkEmpty: function($input) {
            var $field = $input.closest('.field');
            if ($input.val() !== '') {
                $field.addClass('field--filled');
            } else {
                $field.removeClass('field--filled');
            }
        },
        onLoadCheck: function($el) {
            $el.each(function() {
                $(this).triggerHandler('click.field');
            });
        },
        testValue: function($el, event) {
            $el.each(function() {
                var $input = $(this),
                    value = ($input.val() || ''),
                    $field = $input.closest('.field'),
                    length = value.length,
                    pos = false;

                // fulldate
                if ($input.is('[data-fulldate]')) {
                    if (event) {
                        pos = event.target.selectionStart;
                    }
                    $input.attr('maxlength', 10);
                    value = value.replace(/\D/g, "");
                    value = value.replace(/(\d{2})(\d)/, "$1/$2");
                    value = value.replace(/(\d{2}\/\d{2})(\d)/, "$1/$2");
                    value = value.substr(0, 10);
                    $input.val(value);
                    // test position after valus has changed
                    pos = pos - (length - $input.val().length);
                    // select new range
                    $input[0].setSelectionRange(pos, pos);
                    // return;
                }
                // expiry date
                else if ($input.is('[data-expiry]')) {
                    if (event) {
                        pos = event.target.selectionStart;
                    }
                    $input.attr('maxlength', 5);
                    value = value.replace(/\D/g, "");
                    value = value.replace(/(\d{2})(\d)/, "$1/$2");
                    value = value.substr(0,5);
                    $input.val(value);
                    // test position after valus has changed
                    pos = pos - (length - $input.val().length);
                    // select new range
                    $input[0].setSelectionRange(pos, pos);
                }
                // number
                else if ($input.is('[data-number]')) {
                    value = value.replace(/\D/g, "");
                    $input.val(value);
                    // return;
                }
                // qty
                else if ($input.is('[data-qty]')) {
                    $input.val(_self.testQtyValue($input));
                    // return;
                }

                _self.checkEmpty($input);
            });
        },
        testQtyValue: function($input) {
            var qtyData = String($input.data('qty')).split(','),
                min = Number(qtyData[0]),
                max = Number(qtyData[1]),
                value = $input.val();

            value = value.replace(/\D/g, "");

            if (!value.length) {
                value = min;
            }

            if (value < min) {
                value = min;
            } else if (value > max) {
                value = max;
            }

            return value;
        },
        validateIdentical: function($input) {
            var identical = $input.data('identical'),
                $form = $input.closest('.form'),
                $identical = $form.find('[name=' + $input.data('identical') + ']');
            if (!$input.val().length || !$identical.val().length) {
                return false;
            }
            if ($input.val() != $identical.val()) {
                return false;
            }
            return true;
        },
        validateEmail: function ($input) {
            var value = $input.val();
            if (!/[A-Za-z0-9_.\-]+@([A-Za-z0-9_\-]+\.)+[A-Za-z]{2,4}/.test(value)) {
                return false;
            }
            return true;
        },
        validateCheckbox: function ($input) {
            var value = $input.val();
            if (!$input.prop('checked')) {
                return false;
            }
            return true;
        },
        validateEmpty: function ($input) {
            var value = $input.val();
            if (value === '' || value === null) {
                return false;
            }
            return true;
        },
        validateExpiry: function ($input) {
            var value = $input.val();
            if (!/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/.test(value)) {
                return false;
            }
            return true;
        },
        validateFulldate: function ($input) {
            var value = $input.val();
            if (!/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(value)) {
                return false;
            }
            return true;
        },
        validateMinMax: function ($input) {
            var value = $input.val(),
                min = Number($input.attr('min')),
                max = Number( $input.attr('max'));

            if (min && value < min) {
                $input.data('alert', 'The MINIMUM value is ' + min + '.');
                return false;
            } else if (max && value > max) {
                $input.data('alert', 'The MAXIMUM value is ' + max + '.');
                return false;
            }

            $input.removeData('alert');
            return true;
        },
        validateGoogleAddress: function ($input) {
            var value = $input.val();
            if (!$input.data('address')) {
                return false;
            }
            return true;
        },
        validateCreditCard: function ($input) {
            var value = $input.val();
            if (!$input.data('card')) {
                return false;
            }
            return true;
        },
        validateRanking: function ($input) {
            var $group = $input.closest('.field__group'),
                minimum = $group.data('minimum-ranking'),
                totalChecked = $group.find('input[type=checkbox]:checked').length;

            if(totalChecked < minimum) {
                $input.data('alert', 'You need to select a minimum of ' + minimum + ' answer(s).');
                return false;
            }

            return true;
        },
        checkValue: function($input) {
            var required = $input.attr('required'),
                type = $input.attr('type'),
                name = $input.attr('name'),
                flag = true,
                value = $input.val();

            // false / empty
            if (!required) {
                return flag;
            }

            // type
            switch (type) {
                // email
                case 'email':
                    flag = _self.validateEmail($input);
                    break;
                case 'checkbox':
                    flag = _self.validateCheckbox($input);
                    break;
                    // default
                default:
                    flag = _self.validateEmpty($input);
                    break;
            }

            // extra conditions
            // address
            if ($input.is('[data-google-address]')) {
                flag = _self.validateGoogleAddress($input);
            }
            // credit card
            if ($input.is('[data-credit-card]')) {
                flag = _self.validateCreditCard($input);
            }
            // fulldate
            if ($input.is('[data-fulldate]')) {
                flag = _self.validateFulldate($input);
            }
            // expiry date
            if ($input.is('[data-expiry]')) {
                flag = _self.validateExpiry($input);
            }
            // number
            if ($input.is('[data-number]')) {
                flag = _self.validateMinMax($input);
            }
            // ranking
            if ($input.is('[data-ranking]')) {
                flag = _self.validateRanking($input);
            }
            if ($input.data('identical')) {
                flag = _self.validateIdentical($input);
            }

            return flag;
        },
        focus: function($input, flag) {
            var focusClass = 'field--focus';
            if (flag) {
                $input.closest('.field').addClass(focusClass);
            } else {
                $input.closest('.field').removeClass(focusClass);
            }
        },
        onLoadFocus: function() {
            var $el = (document.activeElement) ? $(document.activeElement) : $('body');

            if ($el.is('input, select, textarea')) {
                _self.focus($el, true);
            }
        },
        getCheckboxRadioCheck: function($input) {
            var value = $input.val(),
                type = $input.attr('type');

            if (type === 'radio') {
                if ($input.prop('checked')) {
                    return value;
                }
            } else if (type === 'checkbox') {
                return $input.prop('checked');
            } else {
                return value;
            }
        },
        getCheckboxRankingCheck: function($input) {
            var value = $input.val(),
                type = $input.attr('type'),
                ranking = $input.data('ranking');

            if (type === 'radio') {
                if ($input.prop('checked')) {
                    return value + "--" + ranking;
                }
            } else if (type === 'checkbox') {
                return $input.prop('checked') + "--" + ranking;
            } else {
                return value + "--" + ranking;
            }
        },
        checkboxRadioCheck: function($input) {
            var $label = $input.closest('.field'),
                type = $input.attr('type'),
                name = $input.attr('name');

            if (type === 'radio') {
                $('input[name=' + name + ']').closest('.field').removeClass('field--checked');
            }

            if (!$input.prop('checked')) {
                $label.removeClass('field--checked');
            } else {
                $label.addClass('field--checked');
            }
        },
        checkboxRankingCheck: function($input) {
            var $label = $input.closest('.field'),
                $fieldGroup = $input.closest('.field__group'),
                availableRanking = _self.getCurrentAvailableRanking($fieldGroup);

            $label.removeAttr('data-ranking');

            if (!$input.prop('checked')) {
                $label.removeClass('field--checked');
                $input.data('ranking', 0);
            } else {
                if(availableRanking !== false) {
                    $label.addClass('field--checked');
                    $label.attr('data-ranking', availableRanking);
                    $input.data('ranking', availableRanking);
                }
                else {
                    $label.removeAttr('data-ranking');
                    $input.prop('checked', false);
                }
            }
        },
        getCurrentAvailableRanking: function($inputGroup) {
            var currentRankingMap = [],
                maximumRanking = $inputGroup.data('maximum-ranking');

            for(var i=1; i<=maximumRanking; i++) {
                currentRankingMap[i] = false;
            }

            $inputGroup.find('[data-ranking]').each(function() {
                var ranking = $(this).data('ranking');

                if(ranking) {
                    currentRankingMap[ranking] = true;
                }
            });

            for(var i=1; i<=maximumRanking; i++) {
                if(currentRankingMap[i] == false) {
                    return i;
                }
            }

            return false;
        },
        appendAlert: function ($field, $alert) {
            $field.addClass('field--alert').append($alert);
            $alert.fadeIn(300);
        },
        removeAlert: function ($field) {
            $field.removeClass('field--alert').find('.field__alert').remove();
        },
        onBlurValidation: function($input) {
            var $wrapper = $input.parent(),
                noFocus = ($input.data('nofocus') === undefined) ? false : true;

            // mask validation
            if ($input.is('[data-qty]')) {
                $input.val(_self.testQtyValue($input));
            }

            if (!noFocus) {
                Form.checkFields($wrapper, true);
            } else {
                // if ($input.val()) {
                //     _self.removeAlert($wrapper);
                // }
            }
        },
        uploadFile: function($input) {
            var $form = $input.closest('.form'),
                value = $input.val(),
                $fieldValue = $input.siblings('.field__value');

            $form.data('filesUploaded', false);
            $fieldValue.text(value);
        }
    };

    // extend field
    // $.extend(_self, Datepicker);
    // $.extend(_self, Dropzone);
    // $.extend(_self, CreditCard);
    // $.extend(_self, Autocomplete);
    // $.extend(_self, Rating);
    // $.extend(_self, Address);

    _self.Datepicker = Datepicker;
    // _self.Dropzone = Dropzone;
    // _self.CreditCard = CreditCard;
    // _self.Autocomplete = Autocomplete;
    // _self.Rating = Rating;
    _self.Address = Address;


    // -------------------
    // BINDS
    // -------------------

    // ---------------- responsive select url
    $('[data-selecttab]').on('change.field', function () {
        _self.selectTab($(this));
    });

    // ---------------- responsive select url
    $('body').on('change.field', '[data-selecturl]', function () {
        _self.selectURL($(this));
    });

    // ---------------- edit field
    $('body').on('click.field', '[data-edit-field]', function() {
        _self.edit($(this));
    });

    // ---------------- check field trigger
    $('body').on('checkEmpty', 'input, select, textarea', function() {
        _self.checkEmpty($(this));
    });

    // ---------------- qty input
    $('body').on('click.field', '.field--qty .field__control', function() {
        _self.qtyInput($(this));
    });

    // ---------------- inputs file change
    $('body').on('change.field', 'input[type=file]', function() {
        _self.uploadFile($(this));
    });

    // ---------------- inputs blur validation
    $('body').on('blur.field', 'input, select, textarea', function() {
        _self.onBlurValidation($(this));
    });

    // ---------------- inputs keyup
    $('body').on('keyup.field change.field paste.field input.field', 'input, select, textarea', function(event) {
        _self.testValue($(this), event);
    });
    _self.testValue($('input, select, textarea'));

    // ---------------- inputs focus
    $('body').on('focusin.field', 'input, select, textarea', function() {
        _self.focus($(this), true);
    }).on('focusout.field', 'input, select, textarea', function() {
        _self.focus($(this), false);
    });

    // ---------------- input check
    $('body').on('click.field', 'input[type=checkbox], input[type=radio]', function() {
        var ranking = $(this).attr('data-ranking');
        if (typeof ranking !== typeof undefined && ranking !== false) {
            _self.checkboxRankingCheck($(this));
        }
        else {
            _self.checkboxRadioCheck($(this));
        }
    });
    _self.onLoadCheck($('input[type=checkbox], input[type=radio]'));

    return _self;
});
